<template>
  <div>
    <!-- 绑定店铺 -->
    <el-dialog
      :title="$t('other.a1646')"
      :visible.sync="showTableCopy"
      @close="$emit('update:showTable', false)"
      width="40%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="100px"
        class="demo-dynamic"
      >
        <el-form-item
          :label="$t('other.a359')"
          :rules="[
            {
              required: true,
              message: $t('other.a1647'),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="shopIdList"
            style="width: 100%"
            multiple
            filterable
            allow-create
            default-first-option
            :placeholder="$t('other.a1648')"
          >
            <el-option
              v-for="item in shopInfo"
              :key="item.value"
              :label="item.label+(countryName[item.city])"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="bingShop">{{$t('other.a1466')}}</el-button>
          <el-button @click="resetForm('dynamicValidateForm')">{{$t('other.a1449')}}</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showTableCopy = false"
          >{{$t('other.a5')}}</el-button
        >
      </span>
    </el-dialog>
    <!-- 创建小组 -->
    <el-dialog
      :title="$t('other.a1649')"
      :visible.sync="showTableCopy1"
      @close="$emit('update:showTable1', false)"
      width="40%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="100px"
        class="demo-dynamic"
      >
        <el-form-item prop="name" :label="$t('other.a1650')">
          <el-input v-model="dynamicValidateForm.name"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('other.a359')"
          :rules="[
            {
              required: false,
              message: $t('other.a1647'),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="shopIdList"
            style="width: 100%"
            multiple
            filterable
            allow-create
            default-first-option
            :placeholder="$t('other.a1648')"
          >
            <el-option
              v-for="item in shopInfo"
              :key="item.value"
              :label="item.label+(countryName[item.city])"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('dynamicValidateForm')"
            >{{$t('other.a1466')}}</el-button
          >
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showTableCopy1 = false"
          >{{$t('other.a5')}}</el-button
        >
      </span>
    </el-dialog>

    <!--插入小组运营的费用 -->
    <el-dialog
      :title="flagId"
      :visible.sync="showTableCopy3"
      @close="$emit('update:showTable3', false)"
      width="60%"
    >
      <div style="height: 400px; overflow-y: auto">
        <div v-if="FeeOptions" style="font-size: 18px; padding-bottom: 15px">
          {{$t('other.a1651')}}：
          <span v-show="FeeOptions.years">{{ FeeOptions.years }}年</span>
          <span v-show="FeeOptions.quarters && FeeOptions.timeType == 2"
            >--{{ FeeOptions.quarters }}{{$t('other.a1652')}}</span
          >
          <span v-show="FeeOptions.months && FeeOptions.timeType == 3"
            >--{{ FeeOptions.months }}{{$t('other.a1653')}}</span
          >
          <span style="margin-left:20px">{{$t('other.a1654')}}：￥{{this.housevalue}}</span>
        </div>
        
        <div style="margin-bottom: 15px">
          <el-button size="mini" type="primary" @click="addFee(0)"
            >{{$t('other.a1655')}}</el-button
          >
          <el-button size="mini" type="primary" @click="getHistorFee()"
            >{{$t('other.a1656')}}</el-button
          >
          <el-button
            size="mini"
            v-show="!editorCost"
            type="primary"
            @click="editorFee(0)"
            >{{$t('other.a238')}}</el-button
          >
          <el-button
            size="mini"
            v-show="editorCost"
            type="danger"
            @click="saveFee()"
            >{{$t('other.a216')}}</el-button
          >
          <el-button
            size="mini"
            v-show="editorCost"
            type="danger"
            @click="editorFee(1)"
            >{{$t('other.a146')}}</el-button
          >
        </div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column :label="$t('other.a1657')">
            <template scope="scope">
              <span v-show="!scope.row.editorStatus">{{
                scope.row.costName
              }}</span>
              <el-input
                v-show="scope.row.editorStatus"
                v-model="scope.row.costName"
                :placeholder="$t('other.a1658')"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1659')">
            <template scope="scope">
              <span v-show="!scope.row.editorStatus">￥{{ scope.row.cost }}</span>
              <el-input
                v-show="scope.row.editorStatus"
                v-model="scope.row.cost"
                :placeholder="$t('other.a1659')"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a33')">
            <template scope="scope">
              <el-button
                v-show="!scope.row.editorStatus"
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)"
                >{{$t('other.a312')}}</el-button
              >
              <el-button
                v-show="scope.row.editorStatus && !editorCost"
                size="mini"
                type="danger"
                @click="saveFee(scope.row)"
                >{{$t('other.a216')}}</el-button
              >
              <el-button
                v-show="scope.row.editorStatus"
                size="mini"
                type="danger"
                @click="addFee(1)"
                >{{$t('other.a146')}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div v-if="FeeOptions.timeType == 2" v-for="item in monthByquaters">
          <div
            style="
              width: 100%;
              text-align: center;
              font-size: 18px;
              padding: 8px 0;
            "
          >
            {{ FeeOptions.years }}{{$t('other.a1660')}}--{{ item.key }}{{$t('other.a1653')}}
          </div>
          <el-table :data="item.value" border style="width: 100%">
            <el-table-column :label="$t('other.a1657')">
              <template scope="scope">
                <span v-show="!scope.row.editorStatus">{{
                  scope.row.costName
                }}</span>
                <el-input
                  v-show="scope.row.editorStatus"
                  v-model="scope.row.costName"
                  :placeholder="$t('other.a1658')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a1659')">
              <template scope="scope">
                <span v-show="!scope.row.editorStatus">{{
                  scope.row.cost
                }}</span>
                <el-input
                  v-show="scope.row.editorStatus"
                  v-model="scope.row.cost"
                  :placeholder="$t('other.a1659')"
                ></el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column
					  	  :label="$t('other.a33')"
					  	  >
					  	  <template scope="scope">
					  	  	<el-button v-show="!scope.row.editorStatus" size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('other.a312')}}</el-button>
					  		<el-button v-show="scope.row.editorStatus && !editorCost" size="mini" type="danger" @click="saveFee(scope.row)">{{$t('other.a216')}}</el-button>
					  		<el-button v-show="scope.row.editorStatus" size="mini" type="danger" @click="addFee(1)">{{$t('other.a146')}}</el-button>
					  	  </template>
					  	</el-table-column> -->
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showTableCopy3 = false"
          >{{$t('other.a5')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../../api/moudles/group.js";
import { mapState, mapActions, mapMutations } from "vuex";
import utils from "../../../utils/utils.js";
export default {
  name: "Dialog",
  data() {
    return {
      countryName:{
			                    'TH':this.$t("chat.Thailand"),
			                    'PH':this.$t("chat.thePhilippines"),
			                    'MY':this.$t("chat.Malaysia"),
			                    'ID':this.$t("chat.Indonesia"),
			                    'SG':this.$t("chat.Singapore"),
			                    'TW':this.$t("chat.Taiwan"),
								'VN':this.$t("chat.Vietnam"),
								'th':this.$t("chat.Thailand"),
			                    'ph':this.$t("chat.thePhilippines"),
			                    'my':this.$t("chat.Malaysia"),
			                    'id':this.$t("chat.Indonesia"),
			                    'sg':this.$t("chat.Singapore"),
			                    'tw':this.$t("chat.Taiwan"),
			                    'vn':this.$t("chat.Vietnam")
			                },
      housevalue:'',//总共费用
      flagId: null,
      showTableCopy: false,
      showTableCopy1: false,
      showTableCopy3: false,
      editorCost: false,
      shopIdList: [],
      monthValue: "",
      yearValue: "",
      cost: "",
      mon: null,
      costName: "",
      quartersValue: "",
      shopInfo: null,
      dynamicValidateForm: {
        name: "",
        userId: "",
        shopGroups: [],
      },
      groupId: null,

      options: [
        {
          value: "1",
          label: this.$t('other.a1661'),
        },
        {
          value: "2",
          label: this.$t('other.a1652'),
        },
        {
          value: "3",
          label: this.$t('other.a1662'),
        },
      ],
      value: "",
      tableData: [],
      //  flagId:'0',
      monthByquaters: [],
    };
  },

  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      tableList: (state) => state.userStoreItems.tableList,
      tableCount: (state) => state.userStoreItems.tableCount,
      bindInfoList: (state) => state.userStoreItems.bindInfoList,
      openAutoPre: (state) => state.userStoreItems.openAutoPre,
      closeAutoPre: (state) => state.userStoreItems.closeAutoPre,
      bindSuccess: (state) => state.mygoods.bindSuccess,
      bindError: (state) => state.mygoods.bindError,
      openDia: (state) => state.mygoods.openDia,
    }),
  },
  props: {
    showTable: {
      type: Boolean,
      default: false,
    },
    showTable1: {
      type: Boolean,
      default: false,
    },
    showTable3: {
      type: Boolean,
      default: false,
    },
    groupIdTpp: {
      type: Number,
      default: null,
    },
    FeeOptions: {
      //当前周期信息
      type: Object,
      default: () => {},
    },
    otherCost: {
      type: Array,
      default: () => [],
    },
  },
  created(){
    this.getHistorFee();
  },
  watch: {
    showTable() {
      this.showTableCopy = this.showTable;
    },
    showTable1() {
      this.showTableCopy1 = this.showTable1;
    },
    showTable3() {
      this.showTableCopy3 = this.showTable3;
    },
    groupIdTpp() {
      this.groupId = this.groupIdTpp;
    },
    showTableCopy() {
      if (!this.showTableCopy) {
        this.shopIdList = [];
      }
    },
    // FeeOptions() {
    // 	this.flagId=this.FeeOptions.costType
    // 	console.log(this.flagId)
    // },

    otherCost() {
      console.log(this.otherCost);
      let housevalue = this.otherCost.reduce((pre,cur)=>{
								return pre+cur.cost
              },0)
      this.housevalue = housevalue;
      console.log('总共费用'+housevalue);
      this.getMonthFeeFromQuater(this.otherCost);
      this.flagId =
        this.FeeOptions.costType == 0
          ? this.$t('other.a1663')
          : this.$t('other.a1664');
      if (this.otherCost.length > 0) {
        this.tableData = [];
        this.otherCost.forEach((p) => {
          if (p.timeType == this.FeeOptions.timeType) {
            this.tableData.push({
              costName: p.costName,
              cost: p.cost,
              editorStatus: false,
              id: p.id,
            });
          }
        });

        console.log(this.tableData);
      } else {
        this.tableData = [];
      }
    },
  },
  created() {
    this.init();
  },
  inject: ["reload"],
  methods: {
    ...mapActions("order", [
      "getPrintSheetHistory",
      "getPrintTogether",
      "getGoodsOrder",
      "getSpeciesOrder",
      "getStoreItem",
      "getShopAllItems",
      "viewLogistics",
      "fill_In_logisticsNumber",
      "reloadOrder",
    ]),

    ...mapActions("userStoreItems", ["jiebanItems", "bindItem", "isAutoPre"]),

    editorFee(num) {
      if (num == 0) {
        console.log(this.tableData);
        this.editorCost = true;
        this.tableData.forEach((p) => {
          p.editorStatus = true;
        });
      } else {
        this.editorCost = false;
        this.tableData.forEach((p) => {
          p.editorStatus = false;
        });
      }
    },

    getMonthFeeFromQuater(list) {
      console.log(this.FeeOptions);
      console.log(list);
      this.mon = new Map();
      list.forEach((p) => {
        if (p.months) {
          let ttp = this.mon.get(p.months);
          if (ttp == undefined) {
            ttp = [];
          }
          ttp.push(p);
          this.mon.set(p.months, ttp);
        }
      });
      console.log(this.mon);
      let arr = [];
      this.mon.forEach((value, key) => {
        arr.push({
          key: key,
          value: value,
        });
      });
      this.monthByquaters = arr;
      console.log(arr);
    },
    saveFee(item) {
      if (item) {
        this.FeeOptions.costName = item.costName;
        this.FeeOptions.cost = Number(item.cost);
        this.FeeOptions.months =
          this.FeeOptions.timeType == 2 ? null : Number(this.FeeOptions.months);
        console.log(item);
        console.log(this.FeeOptions);
        api.insetGroupCost(this.FeeOptions).then((res) => {
          if (res.code === 200) {
            this.$message.success(this.$t('other.a1665'));
            this.$emit("updateData", res.data);
            item.editorStatus = false;
          } else {
            this.$message.success(res.msg);
          }
        });
      } else {
        console.log(this.tableData);
        let addFee = [];
        let fixFee = [];
        this.tableData.forEach((p) => {
          if (p.id) {
            fixFee.push(p);
          } else {
            addFee.push(p);
          }
        });
        console.log("addFee", addFee);
        console.log("fixFee", fixFee);

        if (addFee.length > 0) {
          let obj = addFee.map((p) => {
            return {
              cost: Number(p.cost),
              costName: p.costName,
              groupId: this.FeeOptions.groupId,
              costType: this.FeeOptions.costType,
              id: this.FeeOptions.id,
              months:
                this.FeeOptions.timeType == 2
                  ? null
                  : Number(this.FeeOptions.months),
              quarters: this.FeeOptions.quarters,
              shopId: this.FeeOptions.shopId,
              timeType: this.FeeOptions.timeType,
              years: this.FeeOptions.years,
              userId: this.userId,
            };
          });
          console.log(obj);
          obj.forEach((p) => {
            api.insetGroupCost(p).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('other.a1666'));
                this.tableData.forEach((p) => {
                  p.editorStatus = false;
                });
                this.editorCost = false;
                this.$emit("updateData", res.data);
              }
            });
          });
        }
        if (fixFee.length > 0) {
          let obj = fixFee.map((p) => {
            return {
              cost: Number(p.cost),
              costName: p.costName,
              costType: this.FeeOptions.costType,
              groupId: this.FeeOptions.groupId,
              id: p.id,
              months:
                this.FeeOptions.timeType == 2
                  ? null
                  : Number(this.FeeOptions.months),
              quarters: this.FeeOptions.quarters,
              shopId: this.FeeOptions.shopId,
              timeType: this.FeeOptions.timeType,
              years: this.FeeOptions.years,
            };
          });
          obj.forEach((p) => {
            api.updataGroupFee(p).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('other.a1666'));
                this.tableData.forEach((p) => {
                  p.editorStatus = false;
                });
                this.editorCost = false;
                this.$emit("freshData", res.data);
              }
            });
          });
        }
      }
    },

    handleDelete(item) {
      this.FeeOptions.costName = item.costName;
      this.FeeOptions.cost = Number(item.cost);
      this.FeeOptions.id = item.id;

      this.$confirm(this.$t('other.a1667'), this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning",
      }).then(() => {
        if (item.id) {
          console.log(this.tableData);
          console.log(item);
          console.log(this.FeeOptions);
          api.deleteGroupCost(this.FeeOptions).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('other.a1232'));
              this.tableData.forEach((p, index) => {
                if (p.costName == item.costName && p.id == item.id) {
                  this.tableData.splice(index, 1);
                }
              });
              this.$emit("deleteData", this.FeeOptions);
            } else {
              this.$message.success(res.msg);
            }
          });
        } else {
          this.tableData.forEach((p, index) => {
            if (p.costName == item.costName && p.id == null) {
              this.tableData.splice(index, 1);
            }
          });
        }
      });
    },

    addFee(num) {
      if (num == 0) {
        this.tableData.push({
          costName: "",
          cost: 0,
          editorStatus: true,
        });
      } else if (num == 1) {
        this.tableData.splice(this.tableList.length - 1, 1);
      }
    },

    getCostFeeParams() {
      console.log(this.FeeOptions);
      let params = {
        groupId: this.FeeOptions.groupId,
        costType: 0,
        id: this.FeeOptions.id,
        shopId: this.FeeOptions.shopId,
        timeType: parseInt(this.value),
        years: null,
        costName: this.costName,
        cost: Number(this.cost),
      };
      if (this.value == "1") {
        //按年份
        params.years = parseInt(
          utils.getCurrnetTime(this.yearValue).slice(0, 4)
        );
      } else if (this.value == "2") {
        //按季节
        params.years = parseInt(
          utils.getCurrnetTime(this.yearValue).slice(0, 4)
        );
        params.quarters = this.quartersValue;
      } else if (this.value == "3") {
        //按月份
        params.years = parseInt(
          utils.getCurrnetTime(this.monthValue).split("-")[0]
        );
        params.months = parseInt(
          utils.getCurrnetTime(this.monthValue).split("-")[1]
        );
      }
      this.$emit("insetFeeOption", params);
      console.log(params);
    },
    bingShop() {
      let params = this.shopIdList.map((p) => {
        return {
          groupId: this.groupId,
          shopId: p,
          platform: "SHOPEE",
        };
      });
      this.$emit("bindShop", params);
    },

    init() {
      this.shopInfo = utils.getAllshop().slice(1);
      console.log(this.shopInfo);
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dynamicValidateForm.userId = this.userId;
          this.dynamicValidateForm.shopGroups = this.shopIdList.map((p) => {
            return {
              platform: "SHOPEE",
              shopId: p,
            };
          });
          this.$emit("createGroup", this.dynamicValidateForm);
        } else {
          this.$message.error(this.$t('other.a1668'));
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.shopIdList = [];
    },
    getHistorFee() {
      api.getHistoryCostName({ userId: this.userId }).then((res) => {
        if (res.code === 200) {
          console.log("历史费用项", res.data);
          console.log(this.FeeOptions);
          res.data.forEach((p) => {
            p.editorStatus = false;
            if (
              p.costType == this.FeeOptions.costType &&
              p.timeType == this.FeeOptions.timeType
            ) {
              this.tableData.push(p);
            }
          });
        }
      });
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 5px 20px 30px 20px !important;
}
</style>
